import { render, staticRenderFns } from "./Membership.vue?vue&type=template&id=b54ea600&scoped=true&"
import script from "./Membership.vue?vue&type=script&lang=js&"
export * from "./Membership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54ea600",
  null
  
)

export default component.exports